/**
 * Admin tab — plan §11 item 6 ("Admin: master lists and merge tool,
 * positions library, roles note (who may edit rate-card values), backtest
 * status"). §13.4 WP-33b builds the master lists section
 * (tabs/admin/masterLists/**) and, per its orchestrator authorization,
 * replaces WP-03's PlaceholderScreen body with this screen — keeping three
 * labelled empty panel slots for the pieces later WPs still own (the same
 * slot pattern WP-34 used for NegotiationModal's Versions/Calculator slots).
 */
import { MasterListsSection } from './masterLists';

/** One labelled "not built yet" slot — see NegotiationModal.tsx's Versions/Calculator cards. */
function PanelSlot({ title, description }: { title: string; description: string }) {
  return (
    <div className="rounded-xl border border-dashed border-gray-300 p-4 dark:border-gray-600">
      <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-200">{title}</h4>
      <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">{description}</p>
    </div>
  );
}

export function AdminTab() {
  return (
    <div className="mx-auto w-full max-w-[1700px] space-y-6 p-4 sm:p-6 lg:p-8">
      <MasterListsSection />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        <PanelSlot
          title="Positions library"
          description="Seeded positions with basis, date, sponsor context, rationale and owner (§9.2, G10). Built in a later work package."
        />
        <PanelSlot
          title="Roles note"
          description="Who may edit rate-card values — the entitlement is the only gate today (§4.2, decision D16); Site Ops admins control who holds it. Built in a later work package."
        />
        <PanelSlot
          title="Backtest status"
          description="Tier 1-4 pass marks and the go/no-go banner (§12, G12). Built in a later work package."
        />
      </div>
    </div>
  );
}

export default AdminTab;
